export const setCookieExpireDate = () => {
  let twentyDays = 20 * 24 * 60 * 60 * 1000;
  let now = new Date();
  return new Date(now.getTime() + twentyDays);
};
